import api from './api';
import { CreateTransactionRequest } from '../interface/CreateTransactionRequest';

export const transactionService = {
  async createTransaction(userId: string, data: CreateTransactionRequest) {
    return api.post(`/transactions?userId=${userId}`, data);
  },

  /**
   * GET /api/transactions/recent/{userId}
   * Get recent transactions (last 30 days)
   */
  async getRecentTransactions(userId: string, limit: number = 20) {
    return api.get(`/transactions/recent/${userId}?limit=${limit}`);
  },
};

export default transactionService;
